"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSentCommitment = exports.isSentCommitmentType = exports.isReceiveShieldCommitment = exports.convertTransactionStructToCommitmentSummary = void 0;
const events_1 = require("../contracts/railgun-smart-wallet/events");
const formatted_types_1 = require("../models/formatted-types");
const convertTransactionStructToCommitmentSummary = (transactionStruct, commitmentIndex) => {
    const commitmentCiphertextStruct = transactionStruct.boundParams.commitmentCiphertext[commitmentIndex];
    const commitmentCiphertext = (0, events_1.formatCommitmentCiphertext)(commitmentCiphertextStruct);
    const commitmentHash = transactionStruct.commitments[commitmentIndex];
    return {
        commitmentCiphertext,
        commitmentHash,
    };
};
exports.convertTransactionStructToCommitmentSummary = convertTransactionStructToCommitmentSummary;
const isReceiveShieldCommitment = (receiveCommitment) => {
    switch (receiveCommitment.commitmentType) {
        case formatted_types_1.CommitmentType.ShieldCommitment:
        case formatted_types_1.CommitmentType.LegacyGeneratedCommitment:
            return true;
        case formatted_types_1.CommitmentType.TransactCommitment:
        case formatted_types_1.CommitmentType.LegacyEncryptedCommitment:
            return false;
    }
    return false;
};
exports.isReceiveShieldCommitment = isReceiveShieldCommitment;
const isSentCommitmentType = (commitmentType) => {
    switch (commitmentType) {
        case formatted_types_1.CommitmentType.TransactCommitment:
        case formatted_types_1.CommitmentType.LegacyEncryptedCommitment:
            return true;
        case formatted_types_1.CommitmentType.ShieldCommitment:
        case formatted_types_1.CommitmentType.LegacyGeneratedCommitment:
            return false;
    }
    return false;
};
exports.isSentCommitmentType = isSentCommitmentType;
const isSentCommitment = (commitment) => {
    return (0, exports.isSentCommitmentType)(commitment.commitmentType);
};
exports.isSentCommitment = isSentCommitment;
